// test559
(559 && 0);
